var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-prompt-gate"},[_c('DynamicFormModal',{ref:"formModal",on:{"submitted":_vm.onSubmitted,"dismissed":_vm.onDismissed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }